// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"71":"72486626","74":"3cc0eb5a","253":"0b7b39bb","288":"ec61e943"}[chunkId] + ".chunk.css";
};